import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ProductShowcase from './components/ProductShowcase';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import FinalCTASection from './components/FinalCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.cam';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY CAM',
  url: siteUrl,
  description: 'YOYBUY Spreadsheet — современная система покупок через китайские маркетплейсы Taobao и Weidian. Сравнивайте товары в таблицах, оформляйте заказы и экономьте на доставке.',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search-{search_term}',
    },
    'query-input': 'required name=search_term',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ProductShowcase />
        <AboutSection />
        <TestimonialSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}